import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import QRCode from "react-qr-code";

export default function WalletPayment() {
    const location = useLocation();
    const navigate = useNavigate();
    const { userData, paymentMethod, profile } = location.state || {};
    const [walletPhone, setWalletPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [walletResponse, setWalletResponse] = useState(null);

    const age =
        new Date().getFullYear() - new Date(userData?.birthDay).getFullYear();

    const header = {
        token: `${process.env.REACT_APP_BEARER_TOKEN} ${localStorage.getItem("token")
            }`,
    };

    const handleWalletPayment = async () => {
        if (!walletPhone) {
            toast.error("من فضلك أدخل رقم المحفظة");
            return;
        }
        setLoading(true);

        const payload = {
            patient_Name: userData?.patient_Name,
            patient_Phone: walletPhone,
            birthDay: userData?.birthDay,
            gender: userData?.gender,
            age: age,
            email: userData?.email || "test@email.com",
            payment_method_id: paymentMethod,
        };

        try {
            const { data } = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/api/v1/order/create-session?profile=${profile}`,
                payload,
                { headers: header }
            );

            if (data?.success) {
                setWalletResponse(data.invoice.payment_data);
                toast.success("تم إرسال كود الدفع إلى محفظتك");
            } else {
                toast.error("فشل في إنشاء الطلب");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "خطأ في الدفع");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center bg-light px-3"
            style={{ minHeight: "70vh" }}>
            <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "500px" }}>
                <h3 className="mb-3 text-center">الدفع عبر المحفظة الإلكترونية</h3>

                {!walletResponse ? (
                    <>
                        <input
                            type="tel"
                            className="form-control text-center mb-3"
                            placeholder="أدخل رقم المحفظة"
                            value={walletPhone}
                            onChange={(e) => setWalletPhone(e.target.value)}
                        />
                        <button
                            className="btn text-white bgBlack w-100"
                            onClick={handleWalletPayment}
                            disabled={loading}
                        >
                            {loading ? "جاري المعالجة..." : "ادفع الآن"}
                        </button>
                    </>
                ) : (
                    <div className="p-2 " dir="rtl">
                        <div className="mb-3 text-center">
                            <span>رقم المرجع: </span>
                            <b className="main-color">{walletResponse.meezaReference}</b>
                        </div>

                        <p className="text-muted mb-2 text-center">تم إرسال رسالة SMS على رقم المحفظة.</p>

                        <p className="text-muted mb-3 text-center">
                            أو يمكنك الدفع من خلال{" "}
                            <span className="fw-bold main-color">QR-Code</span> عبر تطبيق المحفظة.
                        </p>

                        {walletResponse.meezaQrCode && (
                            <div className="d-flex justify-content-center my-4">
                                <QRCode value={walletResponse.meezaQrCode} size={180} />
                            </div>
                        )}

                        <p
                            className="mb-4 text-secondary text-center "
                            style={{ fontSize: "20px", fontWeight: "600" }}
                        >
                            سيظهر طلبك في صفحة الطلبات بعد إتمام عملية الدفع.
                        </p>

                        <button
                            className="btn btn-new-color w-100"
                            onClick={() => navigate("/allOrderLoggedUser")}
                        >
                            الذهاب إلى الطلبات
                        </button>
                    </div>
                )}
            </div>
        </div>

    );
}
